declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

const PIXEL_ID = '1295313568614005'

export function initMetaPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
  window.fbq('trackSingle', PIXEL_ID, 'PageView')
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('trackSingle', PIXEL_ID, 'AddToCart', {
      content_name: 'El Método Acento Prohibido',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
